<!--
	Standalone placeholder rendered in list views while build data is still
	loading. Reuses BuildCard's real layout classes (.resource-card / __header /
	__header-info / __status / __description) so spacing/structure changes to the
	card propagate here automatically — only the SkeletonBlock widths are
	card-specific.
-->
<template>
	<v-card
		variant="outlined"
		class="resource-card-shell"
		min-width="300px"
		data-test="build-card-skeleton"
	>
		<div class="resource-card">
			<div class="resource-card__header sgnl-paragraph-s-regular">
				<div class="resource-card__header-info">
					<SkeletonBlock
						width="var(--sgnl-icon-20)"
						height="var(--sgnl-icon-20)"
					/>
					<SkeletonBlock
						width="200px"
						height="var(--sgnl-unit-24)"
						radius="var(--sgnl-border-radius-6)"
					/>
					<SkeletonBlock
						width="120px"
						height="var(--sgnl-unit-24)"
						radius="var(--sgnl-border-radius-6)"
					/>
				</div>
				<div class="resource-card__status">
					<SkeletonBlock
						width="var(--sgnl-unit-80)"
						height="var(--sgnl-unit-16)"
						radius="var(--sgnl-border-radius-6)"
					/>
				</div>
			</div>
			<!--
				Pixel widths intentionally mirror the rendered widths of the real BuildCard
				content (Build ID chip, Core chip, status, action buttons). Do not tokenize —
				drift introduces a layout shift when the real card swaps in.
			-->
			<div class="resource-card__description sgnl-flex sgnl-flex-column sgnl-gap-8">
				<!-- 21px mirrors the real .resource-card__source line height (paragraph-s font, default line-height). -->
				<SkeletonBlock
					width="50%"
					height="21px"
					radius="var(--sgnl-border-radius-6)"
				/>
				<SkeletonBlock
					width="50%"
					height="var(--sgnl-unit-24)"
					radius="var(--sgnl-border-radius-6)"
				/>
			</div>
			<div class="sgnl-flex sgnl-align-center sgnl-flex-wrap sgnl-gap-8">
				<SkeletonBlock
					width="122px"
					btn
				/>
				<SkeletonBlock
					width="var(--sgnl-unit-64)"
					btn
				/>
				<SkeletonBlock
					width="var(--sgnl-unit-64)"
					btn
				/>
				<v-spacer />
				<SkeletonBlock
					width="var(--sgnl-unit-64)"
					btn
				/>
			</div>
		</div>
	</v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SkeletonBlock from "@/components/Common/SkeletonBlock.vue";

export default defineComponent({
	name: "BuildCardSkeleton",
	components: { SkeletonBlock },
});
</script>
